/**
 * Specifies the type of operation that is being performed on the object bound against the modal form.
 */
export enum ModalEditMode {
    /** The object is being added. */
    adding,

    /** The object is being edited. */
    editing,

    /** The object is being duplicated. */
    duplicating,

    /** The object is being added via import. */
    importing,
}
